// type
import { DashboardItemType } from 'types/graphql'
// constants
import { FN_TYPE_OPTIONS } from 'components/Modals/WidgetSettingsModal/components/Form/components/FunctionFields'

export const WIDGETS = [
  { active: true, label: 'Section', type: DashboardItemType.Section },
  { active: true, label: 'Image', type: DashboardItemType.Image },
  { active: true, label: 'Function', type: DashboardItemType.Function },
  { active: true, label: 'Card', type: DashboardItemType.Card },
  { active: true, label: 'Strategy Actions', type: DashboardItemType.StrategyActions },
  { active: false, label: 'Bar Chart', type: DashboardItemType.BarChart },
  { active: false, label: 'Line Chart', type: DashboardItemType.LineChart },
  { active: false, label: 'Pie Chart', type: DashboardItemType.PieChart }
]

export const SECTION_DEFAULT_SETTINGS = {
  settings: {
    dropShadow: true,
    showTitle: true,
    padding: 16,
    transparency: 1
  }
}

export const FN_DEFAULT_SETTINGS = {
  settings: {
    width: 100,
    height: 125,
    functionType: FN_TYPE_OPTIONS[0].value
  }
}

export const CARD_DEFAULT_SETTINGS = {
  settings: {
    width: 100,
    height: 125
  }
}

export const SA_DEFAULT_SETTINGS = {
  settings: {
    dropShadow: true,
    showTitle: true,
    padding: 16,
    transparency: 1
  }
}
